import { BadgeV3 } from '@cimplico/components';
import { WorksheetStatusEnum } from '../../../types/worksheet';
import {
    EllipsisHorizontalCircleIcon,
    MinusCircleIcon,
    XCircleIcon,
    ExclamationCircleIcon,
    CheckCircleIcon,
} from '@heroicons/react/20/solid';

type StatusBadgeProps = {
    status: WorksheetStatusEnum;
};

function StatusBadge({ status }: StatusBadgeProps): JSX.Element {
    let badge;
    switch (status) {
        case WorksheetStatusEnum.UNPREPARED:
            badge = <BadgeV3 color="red" label="Unprepared" leftIcon={<MinusCircleIcon />} />;
            break;
        case WorksheetStatusEnum.IN_PROGRESS:
            badge = <BadgeV3 color="yellow" label="In Progress" leftIcon={<EllipsisHorizontalCircleIcon />} />;
            break;
        case WorksheetStatusEnum.AWAITING_REVIEW:
            badge = <BadgeV3 color="blue" label="Awaiting Review" leftIcon={<ExclamationCircleIcon />} />;
            break;
        case WorksheetStatusEnum.REVIEWED:
            badge = <BadgeV3 color="green" label="Reviewed" leftIcon={<CheckCircleIcon />} />;
            break;
        default:
            badge = <BadgeV3 color="gray" label="Excluded" leftIcon={<XCircleIcon />} />;
    }

    return <>{badge}</>;
}

export default StatusBadge;
